import { BlockNoteDocument } from '../schema';

export default function isEmptyParagraph(block: BlockNoteDocument[number]) {
  return (
    block.type === 'paragraph' &&
    Array.isArray(block['content']) &&
    block['content'].length === 0
  );
}
